import { render, staticRenderFns } from "./LiveOrders.vue?vue&type=template&id=f13b5a88&scoped=true&"
import script from "./LiveOrders.vue?vue&type=script&lang=js&"
export * from "./LiveOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13b5a88",
  null
  
)

export default component.exports